module.exports = __webpack_public_path__ + "media/alarm.c6d0db15.wav";